import { GraphSetData } from 'business/data-analysis/pages/graph/hooks/graph-data-context/types';

export const updateValues = (newValues: GraphSetData) => {
  return newValues;
};
